import { Col, Row, Typography, Form, Space, Spin, Button, message, Checkbox } from "antd";
import React, { useState, useEffect } from "react";
import {
  CloseOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import {
  InputField,
  SelectField,
  DateField,
  ReactSelectField,
} from "../../atoms/FormElement";
import { useForm, useWatch, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getACLGroups, getUserList } from "./ducks/actions"
import DashboardLayout from "../../molecules/DashboardLayout";
import SectionHeader from "../../molecules/SectionHeader";
import { Popup } from "../../atoms/Popup";
import { api } from "../../../services/api";

const { Title, Paragraph } = Typography;

const defaultVal = {
  group: "",
  userId: "",
};

const RequestAccess = (props) => {

  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [features, setFeatures] = useState([]);
  const [menu, setMenu] = useState([]);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [submited, setSubmited] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    defaultValues: defaultVal,
  });


  const onFinish = async (values) => {
    setLoader(true);
    setSubmited(true);

    const postJson = Object.keys(permissions).map(key => {
        return {
          value: key,
          features: permissions[key]
        };
      })

    try {

      const res = await api.createAccessRequest(postJson);

      setTimeout(() => {
        reset();
        setLoader(false);
        message.success("Access Request Created successfully");
        setSubmited(false);
        navigate(-1)
      }, 3000);

    } catch (e) {

      setLoader(false);
      setisError(true);
      setErrorMessage(e.message);

    }

  }

  return (
    <>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <SectionHeader heading="Create Request For ACL Access"
              noBorder={true}
              searchName='Category'
              justifiedItems={true}
              justifyEnd={true}
            />
          </Col>
          <Col span={24}>
            <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
              {loader && !isError && (
                <Row gutter={[24, 24]}>
                  <Col span={24}>
                    <Space size={24} className="w-100 text-center" direction="vertical">
                      <Spin size="large" className="ag-fontSize32" />
                      {/* <Paragraph className="ag-default fontWeight600 mb-0">Loading</Paragraph> */}
                    </Space>
                  </Col>
                </Row>
              )}
              {!submited ? (
                <>

                  <Row gutter={24} justify="center">
                    <Col span={8}>
                      <ReactSelectField
                        // isRequired={true}
                        fieldname="menu"
                        label="Menu"
                        control={control}
                        iProps={{
                          placeholder: "Select Menu",
                          isDisabled: !menu.length,
                        }}
                        onChange={(resMenu) => {
                          if(resMenu) {
                            const currentFeatures = JSON.parse(JSON.stringify(features));
                            const currentMenu = JSON.parse(JSON.stringify(menu));
                            
                            if(!currentFeatures.find(feat => feat.value === resMenu.value)) { 
                              currentFeatures.push(resMenu)
                              currentMenu.splice(currentMenu.findIndex(a => a.value === resMenu.value) , 1)
                              setMenu(currentMenu)
                              setFeatures(currentFeatures)
                            }
                          }
                        }}
                        // rules={{
                        //   required: "Please select ticket sub-type",
                        // }}
                        initValue=""
                        selectOption={
                          menu
                        }
                        // validate={errors.ticketsubtype && "error"}
                        // validMessage={
                        //   errors.ticketsubtype && errors.ticketsubtype.message
                        // }
                      />
                    </Col>
                  </Row>

                  {
                    features.map((featValue, key) => 
                    featValue.value === 'comm' && (
                        <Row gutter={24} justify="center" key={key}>
                          <Col span={8}>
                            <Row>
                              <Title level={5}>{featValue.label}</Title> <CloseOutlined onClick={() => {

                                const currentFeatures = JSON.parse(JSON.stringify(features));
                                const currentMenu = JSON.parse(JSON.stringify(menu));

                                currentFeatures.splice(currentFeatures.findIndex(a => a.value === featValue.value) , 1)
                                currentMenu.push(featValue)

                                setFeatures(currentFeatures)
                                setMenu(currentMenu)
                                }} style={{marginTop: 7, marginLeft: 7, cursor: 'pointer'}} />
                            </Row>
                            
                            <Form.Item
                            >
                              <Controller
                                name={featValue.value}
                                control={control}
                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                  <Checkbox.Group
                                    value={value}
                                    ref={ref}
                                    onChange={(e) => {
                                      const deepCopy = JSON.parse(JSON.stringify(permissions)); 
                                      deepCopy[featValue.value] = e
                                      setPermissions(deepCopy)
                                      onChange(e);
                                    }}
                                  >
                                    <Space>
                                      {
                                        featValue?.features
                                        && featValue?.features?.length > 0 && featValue?.features.map((featureValue, key) => <Checkbox value={featureValue} key={key}>{featureValue}</Checkbox>)
                                      }
                                    </Space>
                                  </Checkbox.Group>
                                )}
                              />
                            </Form.Item>
                          </Col>
                          {/* <Col span={4}>
                            <CloseOutlined />
                          </Col> */}
                        </Row> 
                      )
                    )
                  }

                  <Row gutter={24} justify="center">
                    <Col>
                      <Button className="ag-green-button" htmlType="submit">
                        Create Request
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : (
                isError && (
                  <>
                    <Row gutter={[24, 24]}>
                      <Col span={24}>
                        <Space
                          size={24}
                          className="w-100 text-center"
                          direction="vertical"
                        >
                          <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                          <Paragraph className="ag-error fontWeight600 mb-0">
                            {errorMessage}
                          </Paragraph>
                        </Space>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={24}>
                        <Button
                          className="ag-gray-button-outline"
                          htmlType="button"
                          onClick={() => {
                            setSubmited(false);
                            setisError(false);
                          }}
                        >
                          Back
                        </Button>
                      </Col>
                    </Row>
                  </>
                )
              )}
            </Form>
          </Col>
        </Row>
    </>    
  );
};

export default RequestAccess;
